import React from 'react';
import PropTypes from 'prop-types';
import { ColorPickerLabel, Button, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import OrganizationSettings from '../../models/organizationSettings';
import Style from '../../styles/partners/partner-settings.module.css';

export function OrganizationColorHidden({ color = '#0032fa' }) {
    const { t } = useTranslation();
    return (
        <div className={Style['color-container']}>
            <span>{t('ticket.partners.color.label_hidden')}</span>
            <div style={{ background: color }} className={Style['color-square']}></div>
        </div>
    );
}

OrganizationColorHidden.propTypes = {
    color: PropTypes.string
};

export default function OrganizationColor({ color = '#0032fa', organization, onSubmit = () => {}, onCardDone = () => {} }) {
    const { t } = useTranslation();
    const [_color, setColor] = React.useState(color);
    const toast = React.useContext(ToastContext);

    const handleSubmit = React.useCallback(() => {
        let organizationSettings = new OrganizationSettings();
        organizationSettings.color = _color;
        organizationSettings
            .save({
                organizationId: organization.pk
            })
            .then(() => {
                toast.success(t('ticket.partners.color.success.update'));
                onSubmit(_color, onCardDone);
            })
            .catch(e => {
                toast.error(t('ticket.partners.color.error.update'));
            });
    }, [_color, onCardDone]);

    const handleRestore = React.useCallback(() => {
        setColor(color);
    }, [color, setColor]);

    const disabled = React.useMemo(() => {
        if (!_color) {
            return true;
        }
        return color === _color;
    }, [color, _color]);

    React.useEffect(() => {
        setColor(color);
    }, [color]);

    return (
        <>
            <div className={Style['color-picker-container']}>
                <ColorPickerLabel
                    label={t('ticket.partners.color.label')}
                    onChange={(event, value) => {
                        setColor(value);
                    }}
                    value={_color}
                />
            </div>
            <div>
                <Button primary className={Style['submit-button']} disabled={color === _color} onClick={handleSubmit}>
                    {t('ticket.common.action.save')}
                </Button>
                <Button disabled={disabled} onClick={handleRestore}>
                    {t('ticket.common.action.restore')}
                </Button>
            </div>
        </>
    );
}

OrganizationColor.propTypes = {
    color: PropTypes.string,
    organization: PropTypes.object.isRequired,
    onSubmit: PropTypes.func,
    onCardDone: PropTypes.func
};
